export default __webpack_public_path__ + "static/media/PepperoniPizza.e5ebda51.jpg";